/* eslint-disable prefer-destructuring */
import axios from 'axios';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

import {
  apiKey,
  baseURL,
  // eslint-disable-next-line camelcase
  recipient_tracking,
} from '../constants/Endpoints';

const GET_RECIPIENT_USERS_LIST = 'luft/customer/GET_RECIPIENT_USERS_LIST';
const GET_RECIPIENT_USERS_LIST_SUCCESS =
  'luft/customer/GET_RECIPIENT_USERS_LIST_SUCCESS';
const GET_RECIPIENT_USERS_LIST_FAILURE =
  'luft/customer/GET_RECIPIENT_USERS_LIST_FAILURE';

const initialState = {
  recipientUsersList: {
    isFetching: false,
    error: '',
    data: [],
    totalItems: 0,
    currentPage: 1,
    pageLimit: 10, // Default 10
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_RECIPIENT_USERS_LIST: {
      return {
        ...state,
        recipientUsersList: {
          ...state.recipientUsersList,
          isFetching: true,
          error: '',
        },
      };
    }

    case GET_RECIPIENT_USERS_LIST_SUCCESS: {
      const { data, page } = action;
      return {
        ...state,
        recipientUsersList: {
          ...state.recipientUsersList,
          isFetching: false,
          error: '',
          data: data.list,
          totalItems: data.count,
          currentPage: page,
        },
      };
    }

    case GET_RECIPIENT_USERS_LIST_FAILURE: {
      return {
        ...state,
        recipientUsersList: {
          ...state.recipientUsersList,
          isFetching: false,
          error: action.error,
        },
      };
    }

    default:
      return state;
  }
}

export default reducer;

function _getRecipientUsersList() {
  return {
    type: GET_RECIPIENT_USERS_LIST,
  };
}

function _getRecipientUsersListSuccess(data, page) {
  return {
    type: GET_RECIPIENT_USERS_LIST_SUCCESS,
    data,
    page,
  };
}

function _getRecipientUsersListError(error) {
  return {
    type: GET_RECIPIENT_USERS_LIST_FAILURE,
    error,
  };
}

export function getRecipientUsersList(query) {
  return function (dispatch, getState) {
    (async () => {
      dispatch(_getRecipientUsersList());

      const { name, page } = query;

      const pageLimit =
        getState().recipientTracking.recipientUsersList.pageLimit;

      const customerCompanyId = window.localStorage.getItem('Luft/CustomerService/CompanyId');
      const userCompanyId = window.localStorage.getItem('Luft/CompanyId');

      const resultID = (customerCompanyId !== 'undefined' && customerCompanyId) || (userCompanyId !== 'undefined' && userCompanyId);

      const url = `${baseURL}${recipient_tracking.GET_RECIPIENT_USERS_LIST}${resultID}`;

      const handleSkip = () => {
        if ((page - 1) * pageLimit > 0) {
          return (page - 1) * pageLimit;
        }
        return 0;
      };

      try {
        const response = await axios.get(url, {
          headers: {
            'api-td-key': apiKey,
          },
          params: {
            name: name || null,
            skip: handleSkip(),
            take: pageLimit,
          },
        });

        dispatch(_getRecipientUsersListSuccess(response.data, page));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getRecipientUsersListError(error.message),
        );
      }
    })();
  };
}
